import styled from 'styled-components';

import { media } from '../../../styles/constants';

const CombinedImageContainer = styled.div`
  display: flex;
  position: relative;
  min-height: 26rem;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
  }

  > div:first-child {
    width: 80%;
    padding-bottom: 30%;
  }

  > div:last-child {
    position: absolute;
    width: 80%;
    right: 0;
    bottom: 0;
  }

  @media (min-width: ${media.workdetail2ndBreakpoint}) {
    > div:first-child {
      width: 100%;
      padding-bottom: 40%;
    }

    > div:last-child {
      position: absolute;
      width: 100%;
      right: -60%;
      bottom: 0;
    }
  }

  @media (min-width: ${media.desktop}) {
    > div:first-child {
      width: 100%;
      padding-bottom: 35%;
    }
  }
`;

export default CombinedImageContainer;
